import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import bymoLogo from "./img/bymo.png";
import "./App.css";

const Overview = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState(null);
    const [orders, setOrders] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [totalComisionAprobat, setTotalComisionAprobat] = useState(0);
    const [totalComisionAsteptare, setTotalComisionAsteptare] = useState(0);
    const [totalOrders, setTotalOrders] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Persist user session
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setEmail(user.email); // Set authenticated user's email
            } else {
                navigate("/"); // Redirect to login if no user is authenticated
            }
        });
        return () => unsubscribe(); // Cleanup listener on unmount
    }, [navigate]);

    // Fetch user data
    useEffect(() => {
        if (!email) return;

        const fetchOrders = async () => {
            try {
                setLoading(true);
                const userCollection = collection(db, email); // Use email as collection name
                const querySnapshot = await getDocs(userCollection);

                const validOrders = [];
                let comisionAprobatSum = 0;
                let comisionAsteptareSum = 0;
                let orderCount = 0;

                querySnapshot.forEach((doc) => {
                    const data = doc.data();

                    // Retrieve user info from "00info"
                    if (doc.id === "00info") {
                        setUserInfo(data);
                    }

                    // Include only rows with `date`, `status`, and `comision`
                    if (data.date && data.status && data.comision !== undefined) {
                        validOrders.push({ id: doc.id, ...data });

                        // Count only rows with status "aprobat" or "in asteptare" for total orders
                        if (["aprobat", "in asteptare"].includes(data.status.toLowerCase())) {
                            orderCount += 1;
                        }

                        // Sum comision values for "aprobat" and "user"
                        if (["aprobat", "user"].includes(data.status.toLowerCase())) {
                            comisionAprobatSum += data.comision;
                        }

                        // Sum comision values for "in asteptare"
                        if (data.status.toLowerCase() === "in asteptare") {
                            comisionAsteptareSum += data.comision;
                        }
                    }
                });

                setOrders(validOrders);
                setTotalComisionAprobat(comisionAprobatSum.toFixed(2));
                setTotalComisionAsteptare(comisionAsteptareSum.toFixed(2));
                setTotalOrders(orderCount);
            } catch (err) {
                console.error("Error fetching user data:", err);
                setError("An error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [email]);

    const handleLogout = () => {
        auth.signOut();
        navigate("/");
    };

    return (
        <div className="container">
            <div className="logo-container">
                <img src={bymoLogo} alt="BYMO Logo" className="bymo-logo" />
            </div>

            <div className="top-boxes">
                <div className="box-summary">
                    <h3>Comision Aprobat</h3>
                    <p className="description">Suma disponibila pentru a fi utilizata pe magazinul online.</p>
                    <p>{totalComisionAprobat} RON</p>
                </div>
                <div className="box-summary">
                    <h3>Comision in asteptare</h3>
                    <p className="description">Suma care urmeaza a fi aprobata dupa expirarea perioadei de retur.</p>
                    <p>{totalComisionAsteptare} RON</p>
                </div>
                <div className="box-summary">
                    <h3>Total comenzi</h3>
                    <p className="description">Totalul comenzilor plasate cu codul de reducere.</p>
                    <p>{totalOrders}</p>
                </div>
            </div>

            <div className="box">
                <h3>Desfasurator</h3>
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p className="error-message">{error}</p>
                ) : orders.length > 0 ? (
                    <table>
                        <thead>
                        <tr>
                            <th>Data</th>
                            <th>Status</th>
                            <th>Comision</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orders.map((order) => (
                            <tr key={order.id}>
                                <td>{order.date || "N/A"}</td>
                                <td>{order.status || "N/A"}</td>
                                <td>{order.comision || 0} RON</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                ) : (
                    <p>Nicio comanda pentru codul tau de reducere.</p>
                )}

                <p className="description-desfasurator">
                    Comenzile generate de clienti dar si cumparaturile bazate pe comision.
                </p>

            </div>

            <div className="box user-details">
                <h3>Detalii utilizator</h3>
                {userInfo ? (
                    <>
                        <p>Cod Reducere: <strong>{userInfo["Cod Reducere"]}</strong></p>
                        <p>Comision: <strong>{userInfo["Comision"]}</strong></p>
                        <p>Nume: <strong>{userInfo.Name}</strong></p>
                        <p>Data incepere colaborare: <strong>{userInfo["Signed date"]}</strong></p>
                        <p>Email: <strong>{userInfo.email}</strong></p>
                    </>
                ) : (
                    <p>Loading user details...</p>
                )}
            </div>

            <div className="box user-details">


                <h3>Cum sa folosesti comisionul?</h3>
                <p className="description-desfasurator">
                    Intra pe bymo.ro si adauga in cos ce produse doresti. Pe pagina de checkout asigura-te ca folosesti aceasi adresa de email ca cea a contului de aici si va aparea automat optiunea de plata cu credite. Pentru orice intrebari ne poti scrie pe Instagram sau pe Whatsapp.
                </p>
            </div>

            <button className="logout-button" onClick={handleLogout}>
                Logout
            </button>
        </div>
    );
};

export default Overview;
